import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

export interface IElementBaseQuickSettingRect {
    /**
     * 获取浮动工具栏rect
     * @param scale
     * @param isEditorTextExpanded 文字的编辑态中目前是选区还是光标
     */
    getQuickSettingRect(scale: number, isEditorTextExpanded?: boolean): IQuickSettingRect
}
export interface IQuickSettingRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

export const SLIDE_AREA_ID = 'edit-panel';
export const DEFAULT_QUICK_SETTING_RECT = { x: 0, y: 0, width: 0, height: 0 };
const QUICK_SETTING_PADDING = 6;
const GROUP_QUCIKBAR_PADDING = 20;

export class ElementBaseQuickSettingRect implements IElementBaseQuickSettingRect {
    public static getOffset(): { leftOffset: number, topOffset: number } {
        const dom = document.getElementById(SLIDE_AREA_ID);
        let leftOffset = 0;
        let topOffset = 0;
        if (dom) {
            const rect = dom.getBoundingClientRect();
            leftOffset = rect.left;
            topOffset = rect.top;
        }
        return { leftOffset, topOffset };
    }

    public static modifyGroupRect(rect: IRect, scale = 1): IRect {
        return {
            left: rect.left - (GROUP_QUCIKBAR_PADDING * scale),
            top: rect.top - (GROUP_QUCIKBAR_PADDING * scale),
            height: rect.height + (GROUP_QUCIKBAR_PADDING * 2 * scale),
            width: rect.width + (GROUP_QUCIKBAR_PADDING * 2 * scale),
        };
    }

    private model: IElementBaseModel;
    public constructor(model: IElementBaseModel) {
        this.model = model;
    }

    public getQuickSettingRect(scale: number, isEditorTextExpanded?: boolean): IQuickSettingRect {
        const { leftOffset, topOffset } = ElementBaseQuickSettingRect.getOffset();
        let frame = this.model.getFrame?.().frameOnSlide?.() ?? this.model.getFrame?.().getFrameInfo();
        frame = frame.rotate ? getFrameAfterRotate(frame, frame.rotate) : frame;
        return {
            x: (frame.left * scale) + leftOffset,
            y: (frame.top * scale) + topOffset - QUICK_SETTING_PADDING,
            width: frame.width * scale,
            height: (frame.height * scale) + (QUICK_SETTING_PADDING * 2),
        };
    }
}
